/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A2Inputs */

const et_faq_a2 = /** @type {(inputs: Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jah — meie eesmärk on tõsta sinu ettevõte Google Mapsi esikolmikusse, kasutades lokaalset SEO-d, Google Business Profile'i optimeerimist ja konversioonile suunatud veebistrateegiat. Me ei müü tühje klikke ega ilusaid raporteid. Standard- ja kvartalipakettides töötame 90-päevase kasvusprindi põhimõttel. Kui kokkulepitud nähtavus ja päringute kasv ei liigu soovitud suunas, jätkame tööd tasuta, kuni eesmärk on täidetud.`)
};

const en_faq_a2 = /** @type {(inputs: Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes — our goal is to get your business into the top 3 on Google Maps through local SEO, Google Business Profile optimization, and a conversion-focused web strategy. We don't sell empty clicks or pretty reports. In our Standard and Quarterly packages we work in a 90-day growth sprint. If agreed visibility and inquiry growth don't move in the right direction, we continue working for free until the goal is reached.`)
};

/**
* | output |
* | --- |
* | "Yes — our goal is to get your business into the top 3 on Google Maps through local SEO, Google Business Profile optimization, and a conversion-focused web st..." |
*
* @param {Faq_A2Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a2 = /** @type {((inputs?: Faq_A2Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A2Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a2(inputs)
	return en_faq_a2(inputs)
});